export default __webpack_public_path__ + "static/media/logo-small-login.9be3ddaa.svg";